import { requestGet, requestPost } from '@/utils/request';

const api = {
	LIST: '/op/lotto_bet_list',
	UPDATE: '/op/lotto_bet_update',
};

export async function lottoBetList(rootId = 0) {
	return requestGet(api.LIST, {
		rootId,
	});
}

export async function lottoBetUpdate(items, rootId = 0) {
	return requestPost(api.UPDATE, {
		items,
		rootId,
	});
}
